import { render, staticRenderFns } from "./BaseAsideNavItemGroup.vue?vue&type=template&id=59aa7362&scoped=true"
import script from "./BaseAsideNavItemGroup.vue?vue&type=script&lang=js"
export * from "./BaseAsideNavItemGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseAsideNavItemGroup.vue?vue&type=style&index=0&id=59aa7362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aa7362",
  null
  
)

export default component.exports